import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { URLS } from "@/utils/urls.const"

const ONBOARDING_VIDEO_URL = URLS.VIDEO_URLS.SMART_KB

interface SmartKbOnboardingDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onComplete: () => Promise<void>
}

export const SmartKbOnboardingDialog: React.FC<
  SmartKbOnboardingDialogProps
> = ({ open, onOpenChange, onComplete }) => {
  const { translate } = useTranslation()

  const handleComplete = async () => {
    await onComplete()
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>{translate("ONBOARDING/SMART_KB/TITLE")}</DialogTitle>
          <DialogDescription>
            {translate("ONBOARDING/SMART_KB/DESCRIPTION")}
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <video
            src={ONBOARDING_VIDEO_URL}
            controls
            autoPlay
            className="aspect-video w-full rounded-lg border border-grey5"
          />
        </div>
        <DialogFooter>
          <Button onClick={handleComplete}>
            {translate("ONBOARDING/SMART_KB/COMPLETE")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
